// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2cgmz","section_active":"Section_section_active__1BaBR"};